import { useContext } from "react";
import NavigationContext from "../contexts/NavigationContext";

const useNavigationHook = () => useContext(NavigationContext);

export default useNavigationHook;
